import React from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { ProductsCarousel } from './ProductsCarousel';
import { LinkModel, ProductTileModel } from '../../models/globals';
import { CategoryBannerProps } from '../../components/category-banner/CategoryBanner';

interface CategoryProductsProps {
    careerProducts: ProductTileModel[];
    careerSearchLink: LinkModel;
    categoryBanner: CategoryBannerProps;
    fundamentalsProducts: ProductTileModel[];
    fundamentalsSearchLink: LinkModel;
}

const CategoryProducts: React.FC<CategoryProductsProps> = ({
    careerProducts,
    careerSearchLink,
    categoryBanner,
    fundamentalsProducts,
    fundamentalsSearchLink,
}) => {
    if (!careerProducts.length && !fundamentalsProducts.length) return null;

    return (
        <Container className="py-3 my-3">
            <div className="border-bottom border-dark mb-4 pb-3">
                <h2 className="font-weight-light text-muted">{`${categoryBanner.name} Courses`}</h2>
            </div>
            <ProductsSection products={fundamentalsProducts} searchLink={fundamentalsSearchLink} />
            <ProductsSection products={careerProducts} searchLink={careerSearchLink} />
        </Container>
    );
};

interface ProductsSectionProps {
    products: ProductTileModel[];
    searchLink: LinkModel;
}

const ProductsSection: React.FC<ProductsSectionProps> = ({ products, searchLink }) => {
    if (!products.length) return null;

    const { typeName } = products[0];
    const testIdSuffix = `${typeName.toLowerCase().split(' ').join('-')}-products-carousel`;
    return (
        <>
            <strong data-testid={`${typeName.toLowerCase().split(' ').join('-')}-header`}>{typeName}</strong>
            <Button
                aria-label={`Browse All ${typeName} Products`}
                className="align-baseline text-primary"
                href={searchLink.url}
                variant="link"
            >
                {searchLink.name}
            </Button>
            <ProductsCarousel products={products} productsPerPage={2} viewMode="mobile" testIdSuffix={testIdSuffix} />
            <ProductsCarousel products={products} productsPerPage={4} viewMode="tablet" testIdSuffix={testIdSuffix} />
            <ProductsCarousel products={products} productsPerPage={5} viewMode="desktop" testIdSuffix={testIdSuffix} />
        </>
    );
};

export { CategoryProducts, CategoryProductsProps };
